import { useMutation } from '@tanstack/react-query'
import { ProjectStoreControllerFindAll } from '@/apis/v1/project'
import {
  ProxyControllerProxyGet,
  ProxyControllerProxyPost,
} from '@/apis/v1/proxy'

export const useProxyGetMutation = () => {
  return useMutation({
    mutationFn: (values: any) => {
      return ProxyControllerProxyGet(values)
    },
  })
}

export const useProxyPostMutation = () => {
  return useMutation({
    mutationFn: (values: any) => {
      return ProxyControllerProxyPost(values)
    },
  })
}

export const getAllStores = (params: any) => {
  return ProjectStoreControllerFindAll({
    ...params,
  })
}
